import React, { PropsWithChildren, useState } from 'react'
import { createContext } from 'lib/createContext'

type Workflow = {
  isOpen: boolean
  open: () => void
  close: () => void
}

type RulesWorkflowsContextState = {
  createRuleFlow: Workflow
}

const [Context, useRulesWorkflowsContextValue] =
  createContext<RulesWorkflowsContextState>({
    name: 'RulesWorkflowsContext',
  })

export const RulesWorkflowsProvider = ({ children }: PropsWithChildren) => {
  const [isCreateRuleOpen, setIsCreateRuleOpen] = useState(false)

  const value: RulesWorkflowsContextState = {
    createRuleFlow: {
      isOpen: isCreateRuleOpen,
      open: () => setIsCreateRuleOpen(true),
      close: () => setIsCreateRuleOpen(false),
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useRulesWorkflowsContextValue }
